import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import axios from "axios";
import styles from "../AdminDashboard/contentComponents/assessmentstatus.module.css";

const ViewCertificate = () => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    const email = localStorage.getItem("useremail"); // get user email
    if (!email) return;

    axios
      .post("https://casaahaanahotels.com/assessment_status_by_driver", {
        email,
      })
      .then((res) => {
        if (Array.isArray(res.data)) {
          setRows(res.data);
          setFilteredRows(res.data);
        }
      })
      .catch((err) => console.error("API error: ", err));
  }, []);

  const totalPages = Math.ceil(filteredRows.length / itemsPerPage);
  const paginatedRows = filteredRows.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  /* Pagination helpers */
  const getPagination = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page !== "...") setCurrentPage(page);
  };

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  /* Certificate View */
  const handleCertificate = (assId) => {
    const url = `/certificate/${assId}`;
    window.open(url, "_blank");
  };

  return (
    <> 
    <h2 style={{fontWeight: '600', marginBottom: "20px"}}>View Certificate</h2>
    
    <div className="responsive-table-wrapper">
      <table className={styles.assessmentTable}>
        <thead>
          <tr>
            <th>Driver&nbsp;Name</th>
            <th>Company&nbsp;Name</th>
            <th>Department</th>
            <th>View Certificate</th>
          </tr>
        </thead>
        <tbody>
          {paginatedRows.map((r, i) => (
            <tr key={i}>
              <td>{r.driver_name || "Unknown"}</td>
              <td>{r.company_name}</td>
              <td>{r.assessment_type}</td>
              <td style={{ textAlign: "center" }}>
                {r.score > 2 ? (
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "white",
                      width: "80px",
                      textAlign: "center",
                      background: "#88E788",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      margin: "0 auto",
                    }}
                    onClick={() => handleCertificate(r.assessment_id)}
                  >
                    View
                  </p>
                ) : (
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "white",
                      background: "#FF7074",
                      padding: "2px 16px",
                      borderRadius: "4px",
                      width: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      margin: "0 auto",
                    }}
                  >
                    Fail
                  </p>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className={styles.pagination} style={{ margin: "20px" }}>
          <button onClick={handlePrev} disabled={currentPage === 1}>
            Prev
          </button>
          {getPagination().map((page, idx) =>
            page === "..." ? (
              <button key={idx} disabled>
                ...
              </button>
            ) : (
              <button
                key={idx}
                onClick={() => handlePageClick(page)}
                className={page === currentPage ? styles.activePageButton : ""}
              >
                {page}
              </button>
            )
          )}
          <button onClick={handleNext} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}
    </div>
    </>
  );
};

export default ViewCertificate;
